var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],staticClass:"input",class:[
      _vm.type === 'date' ? 'input_date' : '',
      _vm.error ? '-error' : ''
    ],attrs:{"placeholder":_vm.placeholder,"type":_vm.type,"disabled":_vm.disabled},domProps:{"value":_vm.val},on:{"input":_vm.input,"blur":function($event){return _vm.$emit('blur')}}}),_vm._v(" "),(_vm.errorText)?_c('span',{staticClass:"error-text",domProps:{"textContent":_vm._s(_vm.errorText)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }